import { APPLICATION_IDENTIFIER, BASE_URL, DEFAULT_LANGUAGE, ORG_IDENTIFIER } from '../test/test-constants';
import { textArg } from './helpers';

export function apiDefaultArgs(args?) {
  args = args || {};
  return {
    'base-url': args['base-url'] || 'https://sydle-one-platform-dev.sydle.one/api/1/',
    org: args['org'] || 'sydle-one-platform-dev',
    app: args['app'] || 'test',
    language: args['app'] || 'pt',
  };
}

export function apiDefaultArgTypes() {
  return {
    ...textArg('base-url', 'Api'),
    ...textArg('app', 'Api'),
    ...textArg('org', 'Api'),
    ...textArg('language', 'Api'),
  };
}

export function apiArgs(args) {
  const { app, language, org } = args;
  return {
    'base-url': args['base-url'] || BASE_URL,
    app: app || APPLICATION_IDENTIFIER,
    language: language || DEFAULT_LANGUAGE,
    org: org || ORG_IDENTIFIER,
  };
}
